import React from 'react';
import { Box, type Palette } from '@mui/material';
import { VerticalDivider } from '@europrocurement/flexy-components';
import { ClientOpereInfo } from './ClientOpereInfo';
import { ClientReference } from './ClientReference';

interface MainInfoSectionProps {
    clientOpere: {
        raisonSociale: string;
        siren?: string;
        urlToSocieteDotCom?: string;
    };
    dossier: {
        societeRef?: string;
    };
    palette: Palette;
}

export const MainInfoSection: React.FunctionComponent<MainInfoSectionProps> = function ({
    clientOpere,
    dossier,
    palette,
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: '16px',
                alignItems: 'center',
                flexWrap: 'wrap',
            }}
        >
            <ClientOpereInfo
                clientOpere={clientOpere}
                palette={palette}
            />
            <VerticalDivider
                sx={{
                    height: '25px',
                    marginLeft: '5px',
                    marginRight: '5px',
                }}
            />
            <ClientReference
                societeRef={dossier.societeRef}
                // onUpdate={onUpdate}
                // onRefresh={onRefresh}
            />
        </Box>
    );
};
